import { commonViewTexts } from '../common';
import { deleteDialogCommonViewTexts } from './delete-dialog-common';

const targetName = commonViewTexts.koumuten;

export const deleteKoumutenDialogViewTexts = {
  title: targetName,
  message: deleteDialogCommonViewTexts.messageGenerator1(targetName)
} as const;
